// extracted by mini-css-extract-plugin
module.exports = {"root":"PollList_root__Z6yJo","pollLi":"PollList_pollLi__y02iT"};